import React, { useEffect, useState } from 'react';
import { Loader2, UserCheck, UserX } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { setArbeitsMandant } from '../../hooks/useArbeitszeit';

// Sucht einen Bestandsmandanten, sobald die Mandantennummer vollständig eingegeben ist.
export const useMandantNachNummer = (nr) => {
  const [st, setSt] = useState({ m: null, laden: false, gesucht: false });
  useEffect(() => {
    const n = (nr || '').trim();
    if (!/^\d{5,}$/.test(n)) { setSt({ m: null, laden: false, gesucht: false }); return undefined; }
    let alive = true;
    setSt((s) => ({ ...s, laden: true }));
    const t = setTimeout(() => {
      api.get('/register/mandanten', { params: { q: n, limit: 10 } })
        .then((r) => { if (!alive) return; const m = (r.data.items || []).find((x) => x.mandanten_nr === n) || null; if (m) setArbeitsMandant(m.mandanten_nr); setSt({ m, laden: false, gesucht: true }); })
        .catch(() => alive && setSt({ m: null, laden: false, gesucht: true }));
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [nr]);
  return st;
};

export const MandantTreffer = ({ st, testId }) => {
  if (st.laden) return <span className="inline-flex items-center gap-1 text-[11px] text-gray-500" data-testid={`${testId}-laden`}><Loader2 className="w-3 h-3 animate-spin" /> Suche …</span>;
  if (!st.gesucht) return null;
  if (!st.m) return <span className="inline-flex items-center gap-1 text-[11px] text-amber-700" data-testid={`${testId}-keiner`}><UserX className="w-3 h-3" /> Kein Mandant mit dieser Nummer</span>;
  return (
    <span className="inline-flex items-center gap-1 text-[11px] text-emerald-700" data-testid={`${testId}-gefunden`}>
      <UserCheck className="w-3 h-3" /> {st.m.name}{st.m.email ? ` · ${st.m.email}` : ''} · {st.m.portal ? 'Portalnutzer' : 'kein Portalkonto'}
    </span>
  );
};
